import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface AddressCardProps {
  street: string;
  buildingNumber: string;
  town: string;
  stateProvince: string;
  postCode: string;
  country: string;
}

export function AddressCard({
  street,
  buildingNumber,
  town,
  stateProvince,
  postCode,
  country
}: AddressCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Address</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <span className="font-medium">Street:</span>
          <span>{`${buildingNumber} ${street}`}</span>
          <span className="font-medium">Town:</span>
          <span>{town}</span>
          <span className="font-medium">State/Province:</span>
          <span>{stateProvince}</span>
          <span className="font-medium">Post Code:</span>
          <span>{postCode}</span>
          <span className="font-medium">Country:</span>
          <span>{country}</span>
        </div>
      </CardContent>
    </Card>
  );
}